"use client";

import Image from "next/image";
import styles from "./styles.module.scss";
import SearchLogo from "/public/_a/icons/searchOutlined.svg";
import { useEffect, useState } from "react";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export default function ProgramsSearch({ programs, setFilteredPrograms , previousPrograms, query, setQuery}) {

  function searchPrograms(query, programs) {
    query = query.toLowerCase(); // Convert query to lowercase for case-insensitive search
    const queryWithUnderscore = query.replace(/\s+/g, "_");

    return programs?.filter((program) => {
      const { programName, domain,attributes } = program;
      const {BannerSlider}=attributes;
      const {Heading}= BannerSlider || {};
      const {text:heading}=Heading || ''

      // Convert all strings to lowercase for comparison
      const lowercaseProgramName = programName?.toLowerCase();
      const lowercaseHeading = heading?.toLowerCase();
      const lowercaseDomain = domain?.toLowerCase();

      // Check for partial matches in program_name, domain, or specializations
      return (
        lowercaseProgramName?.includes(query) || lowercaseHeading?.includes(query) ||
        lowercaseDomain?.includes(query) || lowercaseDomain?.includes(queryWithUnderscore)
      );
    });
  }


  const debouncedSearch = debounce((query) => {
    if (query) {
    setFilteredPrograms(searchPrograms(query, programs));
    
    }
    else {
      // If the query is empty, reset to the full list of programs
      setFilteredPrograms(previousPrograms);
    }
  }, 600); // Adjust the delay as needed

  useEffect(() => {
    debouncedSearch(query);
    if(query){
      // Call pushToDataLayer only after debounced search
      const handleDataLayerPush = () => {
        pushToDataLayer({
          event: 'search_bar_fill',
          cta_text: query || "NA",
          section_name: 'Explore our online degree programs',
          page_type: getGlobalStateValue('pageType') || "Home Page"
        });
      };
      const timeoutId = setTimeout(handleDataLayerPush, 600); // Match the debounce delay
      return () => clearTimeout(timeoutId); // Cleanup timeout on unmount or query change
    }
  }, [query]);

  return (
    <div className={styles.searchContainer}>
      <input
        type="text"
        placeholder="Search by program name, domain, specialization"
        className={styles.searchInput}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <Image src={SearchLogo} alt="Search" className={styles.searchLogo} />
    </div>
  );
}
